var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"widget-container"},[_c('v-card',{staticClass:"custom-card",attrs:{"color":"secondary"}},[_c('v-card-title',{staticStyle:{"color":"#fff"}},[_vm._v(" Statistics ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }